import { useChannelStateContext } from 'stream-chat-react'
import { StyledStack } from './styles'
import { Typography, CircularProgress } from '@mui/material'

export function CustomTypingIndicator() {
  const { channelConfig } = useChannelStateContext()

  if (channelConfig?.typing_events !== false) {
    return null
  }

  return (
    <StyledStack key="typingIndicator">
      <CircularProgress size={16} thickness={4} color="inherit" />
      <Typography color="$color-text-primary" variant="$font-body-2">
        Sentinela está trabalhando
      </Typography>
    </StyledStack>
  )
}
